import { MemberType } from "@shared/member.utils";
import icon_baby from "../assets/icon_baby.svg";
import icon_kid from "../assets/icon_kid.svg";
import icon_parent from "../assets/icon_parent.svg";

export const getMemberIcon = (type: MemberType) => {
  switch (type) {
    case "adult":
      return icon_parent;
    case "junior":
      return icon_kid;
    case "baby":
      return icon_baby;
    default:
      return icon_parent; // fallback to parent icon
  }
};

export const getMemberTypeLabel = (type: MemberType) => {
  switch (type) {
    case "adult":
      return "Adulto";
    case "junior":
      return "Junior";
    case "baby":
      return "Bambino";
    default:
      return "Adulto"; // fallback to adult label
  }
};
